<div class='admissions-engagements-tab1-part'>
	<staff-engagement-counts [data]="staffEngagementData()"></staff-engagement-counts>
</div>